import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';


import { BsModalComponent, BsModalBodyComponent, BsModalService } from 'ng2-bs3-modal';
import 'jquery'
import 'bootstrap'

//import { Lists_cmmt } from '../../../routes/menu'


const swal = require('sweetalert');
@Component({
  selector: 'app-daotao-chuyenlopedit',
  templateUrl: './chuyenlopedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./chuyenlopedit.component.scss'],
    providers: [ListService, Repository]
})


export class chuyenlopeditComponent implements OnInit {
  doanhnghiepid: string = null;
  public ngaysinh: Date = null;
  public ngaycmnd: Date = null;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any;
  inputhangbaohiems: any;
  inputphongbans: any;
  inputhangxes: any;
  inputkhachhangs: any;
  inputmausacs: any;
  inputmodels: any;
  inputnhomctmts: any;
  indLoading: boolean = false;
  dschinhanhs: any;

  doituongSelect: any = {
    Id: null, LyDo: null, Ten: null
    , Ngay: null, GhiChu: null, NhanSuId: null
    , DonViCuId: null, LopCuId: null, DonViId: null, LopId: null
    ,Created: null, Modified: null, CreatedBy: null, ModifiedBy: null

  };       
    nhomdtid:string=null;
  hoatdong: string = null;
  inputnhacungcaps: any = [
    { Ten_Doi_Tuong: "Cá nhân", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Tổ chức", Ma_Doi_Tuong: '1', Id: true },
  ];

  inputthus: any = [
    { Ten: 'Thứ 2', Id: 2 },
    { Ten: 'Thứ 3', Id: 3 },
    { Ten: 'Thứ 4', Id: 4 },
    { Ten: 'Thứ 5', Id: 5 },
    { Ten: 'Thứ 6', Id: 6 },
    { Ten: 'Thứ 7', Id: 7 },
    { Ten: 'Chủ nhật', Id: 8 }
  ];

  inputgioitinhs: any = [
    { Ten_Doi_Tuong: "Nữ", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Nam", Ma_Doi_Tuong: '1', Id: true },
  ];

  inputloais: any = [
    { text: "Nhân công", value: 0 },
    { text: "Vật tư sơn", value: 1 },
  ];

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();

  @ViewChild('mdChonDoiTuongChung') mdChonDoiTuongChung: BsModalComponent;
  @ViewChild('dtechondoituongchungedit') dtechondoituongchungedit: any;
  
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };

    constructor( private _dataService: ListService, public repo: Repository) {
       
        
    }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  bnhomctmt: boolean = false;
  currentUser: any;
  tieudectmt: any;
  tieudectmtplace: any;
  row: any;

  dslopcus: any;
  dslopmois: any;

  public changeCNCu($event: any) {
    if (typeof $event === "undefined") {
      this.doituongSelect.LopcuId = null;
    }
    else {

      this.repo.postRequest('api/hoso/combolophoc', { UserName: this.currentUser.user_name, DonViId: $event.Id })
        .subscribe(response => {
          this.dslopcus = response;

        });


      }
  }
  public changeCNMoi($event: any) {
    if (typeof $event === "undefined") {
      this.doituongSelect.LopId = null;
    }
    else {

      
      this.repo.postRequest('api/hoso/combolophoc', { UserName: this.currentUser.user_name, DonViId: $event.Id })
        .subscribe(response => {
          this.dslopmois = response;

        });


    }
  }
 
  loadDataInit(nhomdoituongid: string, id: string, donviid: string, rowdata : any, lopid: string) {

    this.row = rowdata;
    this.tieudectmtplace = "Ghi chú";
    this.tieudectmt = "Ghi chú";

      this.hoatdong = "Hoạt động"

          var authlogin = localStorage.getItem('currentUser');
          if (authlogin) {

            this.currentUser = JSON.parse(authlogin);
           
            

          }


    this.repo.postRequest('api/login/gettrungtam2s', { UserName: this.currentUser.user_name })
      .subscribe(response => {
        this.dschinhanhs = response;
      });

   

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
    }, 500);
    
    
    this.doituongSelect = {
      Id: null, LyDo: null, Ten: null
      , Ngay: null, GhiChu: null, NhanSuId: null
      , DonViCuId: null, LopCuId: null, DonViId: null, LopId: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    };    
    if (id === null)
    {
      

      
      this.doituongSelect.Created = new Date();
          this.doituongSelect.CreatedBy = this.currentUser.user_name;
          this.doituongSelect.Modified = new Date();
      this.doituongSelect.ModifiedBy = this.currentUser.user_name;

      this.doituongSelect.DonViCuId = donviid;
      this.doituongSelect.DonViId = donviid;
      this.doituongSelect.LopCuId = lopid;
      this.doituongSelect.NhanSuId = nhomdoituongid;
      this.doituongSelect.Ngay = new Date();
      this.repo.postRequest('api/hoso/combolophoc', { UserName: this.currentUser.user_name, DonViId: donviid })
        .subscribe(response => {
          this.dslopcus = response;
        });

      this.repo.postRequest('api/hoso/combolophoc', { UserName: this.currentUser.user_name, DonViId: donviid })
        .subscribe(response => {
          this.dslopmois = response;


        });
          
    }
        else {

      this.doituongSelect.Id = id;
      
      this.doituongSelect.Created = new Date();
      this.doituongSelect.CreatedBy = this.currentUser.user_name;
      this.doituongSelect.Modified = new Date();
      this.doituongSelect.ModifiedBy = this.currentUser.user_name;

      this.doituongSelect.Ngay = new Date();
      this.doituongSelect.DonViCuId = this.row.DonViId;
      this.doituongSelect.DonViId = this.row.DonViId;
      this.doituongSelect.LopCuId = this.row.LopId;
      this.doituongSelect.NhanSuId = this.row.NhanSuId;

      
      this.repo.postRequest('api/hoso/combolophoc', { UserName: this.currentUser.user_name, DonViId: this.doituongSelect.DonViCuId })
        .subscribe(response => {
          this.dslopcus = response;
        });
      

      this.repo.postRequest('api/hoso/combolophoc', { UserName: this.currentUser.user_name, DonViId: this.doituongSelect.DonViId })
        .subscribe(response => {
          this.dslopmois = response;
          

        });





        }
        
       
    }
   
    keyTenPress(event: any) { 
        if (event.which === 13) {
            this.slCapTren.focus();
            event.preventDefault();
          }
  }
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
    public closeModal(){
        this.save.emit(null);
    }
  public saveproduct() {
    if (this.doituongSelect.LyDo == null || this.doituongSelect.LyDo == "") {
      swal('Lỗi!', 'Vui lòng nhập lý do chuyển lớp!.', 'error');
      return;
    }
    if (this.doituongSelect.Ngay == null || this.doituongSelect.Ngay == "") {
      swal('Lỗi!', 'Vui lòng nhập ngày!.', 'error');
      return;
    }

    if (this.doituongSelect.DonViCuId == null || this.doituongSelect.DonViCuId == "") {
      swal('Lỗi!', 'Vui lòng nhập CN cũ!.', 'error');
      return;
    }
    if (this.doituongSelect.LopCuId == null || this.doituongSelect.LopCuId == "") {
      swal('Lỗi!', 'Vui lòng nhập lớp cũ!.', 'error');
      return;
    }

    if (this.doituongSelect.DonViId == null || this.doituongSelect.DonViId == "") {
      swal('Lỗi!', 'Vui lòng nhập CN mới!.', 'error');
      return;
    }
    if (this.doituongSelect.LopId == null || this.doituongSelect.LopId == "") {
      swal('Lỗi!', 'Vui lòng nhập lớp mới!.', 'error');
      return;
    }
   
    
    $('#loading').show();
    this.repo.postRequest("api/khoahoc/addorupdate_dthocvien",this.doituongSelect)
            .subscribe(response => {  
              $('#loading').hide();
              if (response != null && response=="OK") {
                this.save.emit(this.doituongSelect);
              }
              else {
                swal('Lỗi!', response, 'error');
              }
            }); 
    }
   
  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
  indexdt: number;
  cotdt: string;


   


}
